import { Location, NgIf } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { PoMenuComponent, PoMenuItem, PoModule, PoToolbarAction, PoToolbarProfile } from "@po-ui/ng-components";
import { AppService } from "./services/app.service";
import { MenuService } from "./services/menu.service";
import { TokenDataService } from "./services/token.data.service";
import { StorageMenuAcess, UserMenuAcess } from "./models/storageMenuAcess.model";
import { clearSessionData } from "./utils/clearSessionData.util";
import { LocalStorageType } from "./types/localStorage.type";
import { CompanyDataService } from "./services/company-data.service";
import { formatCNPJ, formatCPF } from "./utils/format.utils";
import { TenantService } from "./services/tenant.service";

@Component({
  standalone: true,
  imports: [PoModule, RouterOutlet, NgIf],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  @ViewChild(PoMenuComponent, {static: false}) poMenuComponent!: PoMenuComponent;

  constructor(
    private router: Router,
    private location: Location,
    private menuService: MenuService,
    private appService: AppService,
    private tokenDataService: TokenDataService,
    private companyDataService: CompanyDataService,
    private route: ActivatedRoute,
    private tenantService : TenantService

  ) {
    this.router.events.subscribe(async (ev) => {
      if(ev instanceof NavigationEnd) {
        if (this.location.path().startsWith('/login')) {
          this.isLoggedIn = false;
        }
        else {
          if(this.location.path() === '/login' ||
          this.location.path() === '') {
            this.isLoggedIn = false;
          }
          else {
            if(this.location.path() !== '/register' && this.location.path() !== '/change-password') {
              this.menu = await this.menuService.getMenu();
              await this.getPoToolbarProfileData();
              await this.getBranches();
              this.isLoggedIn = true;
              if(this.location.path() !== '/home')
                if (this.poMenuComponent && this.poMenuComponent.activeMenuItem) {
                  this.onSaveMenuAcessStore(this.poMenuComponent);
                }
            }
          }

          if(this.location.path() === '/blocked') {
            this.poMenuComponent.activeMenuItem = { label: ""};
            this.poMenuComponent.groupedMenuItem = { label: ""};
            this.poMenuComponent.linkActive = "";
          }
        }
      }
    });
  }

  ngOnInit() {
    this.appService.appTitle = this.appTitle;
    this.appService.imageMenuCode = this.imageMenuCode;
    this.appService.loginTheme = this.loginTheme;      
  }

  @Input() public appTitle!: string;
  @Input() public imageMenuCode!: number;
  @Input() public loginTheme!: string | null;

  isLoggedIn: boolean = false;

  profile: PoToolbarProfile = {
    avatar: '',
    title: 'Username',
  }

  logo = 'assets/totvsLogo.png';

  menu!: Array<PoMenuItem>;

  profileActions: Array<PoToolbarAction> = [
    {
      icon: 'po-icon-exit',
      label: 'Sair',
      type: 'danger',
      separator: true,
      action: () => this.onLogout({withCallback: false})
    }
  ];

  private onLogout(options: { withCallback: boolean }): void {
    clearSessionData();

    if(options.withCallback)
      localStorage.setItem(LocalStorageType.CallbackUrl, this.location.path());

    this.router.navigate(['/login'], { queryParams: { tenant: this.tenantService.getTenant() } });
    this.isLoggedIn = false;
  }

  private async getPoToolbarProfileData(): Promise<void> {
    const userDocument = localStorage.getItem(LocalStorageType.UserDocument) ;
    if (userDocument) {
      if (userDocument.length > 11) {
        this.profile.title = formatCNPJ(userDocument);
      } else {
        this.profile.title = formatCPF(userDocument);
      }
    } else {
      this.profile.title = '00000000000000';
    }
  }

  private onSaveMenuAcessStore(menuItem: PoMenuComponent) {
    const userKey = this.generateUserKeyLocals();
    const menu = JSON.stringify(menuItem.activeMenuItem);
    const localStorageMenu = localStorage.getItem(userKey);

    if(localStorageMenu) {
      const menuItens = JSON.parse(localStorageMenu).storageMenuAcess;

      const menuFind = menuItens.find((item: StorageMenuAcess) => item.code === JSON.parse(menu).code);

      if(menuFind) {
        menuFind.countAcess += 1;
      } 
      else {
        const novoMenu: StorageMenuAcess = {
          code: JSON.parse(menu).code,
          componentDescription: JSON.parse(menu).componentDescription,
          icon: JSON.parse(menu).icon,
          link: JSON.parse(menu).link,
          countAcess: 1
        };

        menuItens.push(novoMenu);
      }

      const userMenuAcess = new UserMenuAcess();
      userMenuAcess.userCode = this.tokenDataService.userCode;
      userMenuAcess.tenant = this.tokenDataService.tenant;

      userMenuAcess.storageMenuAcess = menuItens;

      const userMenuAcessString = JSON.stringify(userMenuAcess);
      localStorage.setItem(userKey, userMenuAcessString);
      return;
    }

    const user = new UserMenuAcess();
    user.userCode = this.tokenDataService.userCode;
    user.tenant = this.tokenDataService.tenant;

    const menuAcess = new StorageMenuAcess();

    menuAcess.code = JSON.parse(menu).code;
    menuAcess.componentDescription = JSON.parse(menu).componentDescription;
    menuAcess.icon = JSON.parse(menu).icon;
    menuAcess.link = JSON.parse(menu).link;
    menuAcess.countAcess += 1;

    user.storageMenuAcess.push(menuAcess);

    const itemsJson = JSON.stringify(user);

    localStorage.setItem(userKey, itemsJson);
  };

  private generateUserKeyLocals(): string {
    const keyUserLocals = 
    this.tokenDataService.userCode + 
    ':' +
    this.tokenDataService.tenant;

    return btoa(keyUserLocals);
  }

  private async getBranches(): Promise<void> {   
    const companyCode = this.tokenDataService.companyCode;    
    const companies = await this.companyDataService.getBranches();
  }

}